import { render, staticRenderFns } from "./DetalleObligacion.vue?vue&type=template&id=08702584&"
import script from "./DetalleObligacion.vue?vue&type=script&lang=js&"
export * from "./DetalleObligacion.vue?vue&type=script&lang=js&"
import style0 from "./DetalleObligacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports